import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useUser} from 'features/authorized/context/user'
import {UserData} from 'features/common/core/entitites'
import {useAuth} from 'features/common/context/auth'
import {OnboardingStage} from '../../../core/entities'
import {onboardingStageByAction} from '../../../core/constants'

const stagesInOrder: OnboardingStage[] = ['email', 'stripe']

const useOnboardingPage = () => {
    const [stage, setStage] = useState<OnboardingStage | null>(null)
    const {logout} = useAuth()
    const {user} = useUser() as {user: UserData}
    const {stage: stageParam} = useParams()

    useEffect(() => {
        const nextStageAction = user.onboarding.next_action?.id
        const nextStage = onboardingStageByAction[nextStageAction || 'email']
        setStage(nextStage)
    }, [stageParam, user.onboarding.next_action?.id])

    const onClickBack = () => {
        setStage((currentStage) => {
            if (currentStage) {
                const currentIdx = stagesInOrder.indexOf(currentStage)
                if (currentIdx > 0) {
                    return stagesInOrder[currentIdx - 1]
                }
            }
            logout()
            return currentStage
        })
    }
    return {
        stage,
        onClickBack,
    }
}
export default useOnboardingPage
